// src/constants/rfqStatus.js

export const RFQ_STATUS = {
  0: { label: "Created", color: "#E3F2FD" },          // light blue
  1: { label: "Live", color: "#E8F5E9" },             // light green
  2: { label: "Quotation Submitted", color: "#E1F5FE" },
  3: { label: "Awarded", color: "#E8F5E9" },
  4: { label: "Rejected", color: "#FDECEA" },      // light red
  5: { label: "Requested More Info", color: "#FFF8E1" },
  6: { label: "Awarded", color: "#E8F5E9" },
  7: { label: "Invoice Raised", color: "#E1F5FE" },
  8: { label: "Shipped", color: "#FDECEA" },
  9: { label: "Out for delivery", color: "#FDECEA" },
  10:{ label: "Delivered", color: "#FFF3E0" },
  11:{ label: "Qualified", color: "#E1F5FE" },
  12:{ label: "Closed", color: "#ECEFF1" },
  13:{ label: "Under evaluation", color: "#E8F5E9" },
  14:{ label: "⁠Not awarded", color: "#FDECEA" },
  15:{ label: "Completed", color: "#E8F5E9" },

};

// Dropdown values (single source)
export const STATUS_DROPDOWN = [
  "Created",
  "Live",
  "Quotation Submitted",
  "Qualified",
  "Awarded",
  "Not Awarded",
  "Rejected",
  "Under Evaluation",
  "Invoice Raised",
  "Closed",
  "⁠Quotation Approved"
];

// helper function
export const getStatusProps = (status) => {
  return RFQ_STATUS[status] || {
    label: "Unknown",
    color: "#ECEFF1",
  };
};
export const ORDER_STATUSES = {
  3: { label: "Awarded", className: "status-green" , color: "#E8F5E9"},
  4: { label: "Rejected", className: "status-orange",color: "#FDECEA"},
  6: { label: "Awarded", className: "status-green",color: "#E8F5E9"  },
  7: { label: "Invoice Raised", className: "status-blue" , color: "#E1F5FE"},
  8: { label: "Shipped", className: "status-blue" , color: "#E1F5FE"},
  9: { label: "Out for delivery", className: "status-blue" , color: "#E1F5FE"},
  10: { label: "Delivered", className: "status-blue" , color: "#E1F5FE"},
  15: { label: "Completed", className: "status-green" , color: "#E8F5E9"},

};
